import * as Types from '../generated/graphql';

import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type AnalyzePlanSubmittalMutationVariables = Types.Exact<{
  input: Types.AnalyzePlanSubmittalInput;
}>;


export type AnalyzePlanSubmittalMutation = { __typename?: 'mutation_root', analyze_plan_submittal?: { __typename?: 'AnalyzePlanSubmittalOutput', success: boolean, job_id?: any | null, plan_review_id?: any | null, submission_number?: number | null, organization_id?: string | null, property_id?: string | null, error?: string | null, payment_required?: boolean | null, extra_resubmittal_price?: number | null, cycle_number?: number | null } | null };


export const AnalyzePlanSubmittalDocument = gql`
    mutation analyzePlanSubmittal($input: AnalyzePlanSubmittalInput!) {
  analyze_plan_submittal(input: $input) {
    success
    job_id
    plan_review_id
    submission_number
    organization_id
    property_id
    error
    payment_required
    extra_resubmittal_price
    cycle_number
  }
}
    `;
export type AnalyzePlanSubmittalMutationFn = Apollo.MutationFunction<AnalyzePlanSubmittalMutation, AnalyzePlanSubmittalMutationVariables>;

/**
 * __useAnalyzePlanSubmittalMutation__
 *
 * To run a mutation, you first call `useAnalyzePlanSubmittalMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAnalyzePlanSubmittalMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [analyzePlanSubmittalMutation, { data, loading, error }] = useAnalyzePlanSubmittalMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useAnalyzePlanSubmittalMutation(baseOptions?: Apollo.MutationHookOptions<AnalyzePlanSubmittalMutation, AnalyzePlanSubmittalMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AnalyzePlanSubmittalMutation, AnalyzePlanSubmittalMutationVariables>(AnalyzePlanSubmittalDocument, options);
      }
export type AnalyzePlanSubmittalMutationHookResult = ReturnType<typeof useAnalyzePlanSubmittalMutation>;
export type AnalyzePlanSubmittalMutationResult = Apollo.MutationResult<AnalyzePlanSubmittalMutation>;
export type AnalyzePlanSubmittalMutationOptions = Apollo.BaseMutationOptions<AnalyzePlanSubmittalMutation, AnalyzePlanSubmittalMutationVariables>;